export default __webpack_public_path__ + "static/media/05_o_preview_0.874dab98.jpg";